import { message } from "antd";
import { IoCloseCircle } from "react-icons/io5";

const generateKey = () =>
  `msg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

const customErrorMessage = text => {
  const key = generateKey();

  message.open({
    key,
    duration: 0,
    content: (
      <div className="inline-flex items-center gap-2 p-1">
        <IoCloseCircle className="text-red-500 text-lg" />

        <span className="text-xs text-gray-800">{text}</span>

        <button
          type="button"
          onClick={() => message.destroy(key)}
          className="
            ml-2
            text-gray-400
            hover:text-gray-600
            transition
            text-xs
            leading-none
            focus:outline-none
          "
          aria-label="Close"
        >
          ✕
        </button>
      </div>
    ),
  });
};

export default customErrorMessage;
